import { useCallback, useEffect, useRef, useState } from "react";

export const useAddressClipboard = (address, enabled) => {
  const [state, setState] = useState("idle");
  const [sequence, setSequence] = useState(0);
  const timer = useRef(null);
  const mounted = useRef(false);
  const current = useRef(address);
  current.current = address;
  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; clearTimeout(timer.current); };
  }, []);
  useEffect(() => { clearTimeout(timer.current); setState("idle"); }, [address]);
  const copy = useCallback(async () => {
    if (!enabled || state === "copying") return;
    clearTimeout(timer.current);
    setState("copying");
    try {
      if (!navigator.clipboard?.writeText) throw new Error("Clipboard unavailable");
      await navigator.clipboard.writeText(address);
      if (!mounted.current || current.current !== address) return;
      setState("copied");
      setSequence((value) => value + 1);
      timer.current = setTimeout(() => { if (mounted.current) setState("idle"); }, 2000);
    } catch {
      if (mounted.current && current.current === address) setState("error");
    }
  }, [address, enabled, state]);
  return { state, sequence, copy };
};